import { useContext, useState } from 'react';
import { ExtraBase, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { ItemExtrasAutoApplier } from '../../../lib/helpers/ItemExtrasAutoApplier';
import { ApplierOption } from '../../../lib/helpers/ApplierOption';
import { ExtrasHaveChanged } from '../../../lib/helpers/SmartSendSocketHelper';
import { SmartSendContext } from '../../../lib/context/SmartSendContext';
import { SaveItemsAction } from '../../../lib/context/SmartSendContextModels';
import { ProtectionSelection } from '../ProtectionSelection';
import { ProtectionExtraIds } from '../../ExtrasHelper';
import { P2GButton } from '@parcel2go/core-ui';
import { useSmartSendApi } from '~/lib/api/smartsend/use-smartsend-api';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  item: SmartSendItemApiModel;
}

export default function ItemProtectionSummaryDrop(props: props) {
  const ctx = useContext(SmartSendContext);
  const { getQuoteOptions } = useSmartSendApi();
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  const [item, setItem] = useState<SmartSendItemApiModel>(
    ItemExtrasAutoApplier(JSON.parse(JSON.stringify({ ...props.item })))
  );

  const getQuote = async () => {
    if (!item.Service) {
      return null;
    }

    const r = await getQuoteOptions(
      item.Service?.Provider,
      item.Service?.AccountId,
      ItemExtrasAutoApplier(item),
      item.Service?.Id
    );

    return r.success ? r.result.Quotes[0] : null;
  };

  const onExtrasSave = (extras: ExtraBase[]) => {
    setItem({ ...item, Extras: extras });
  };

  const onSave = () => {
    if (ExtrasHaveChanged(props.item.Extras, item.Extras)) {
      const actions: ApplierOption[] = [];
      actions.push('Extras');
      ctx.dispatch(
        new SaveItemsAction([item.Id], actions, {
          Extras: item.Extras
        })
      );
    }
  };

  return (
    <>
      <ProtectionSelection
        currentCoverPercentage={item.State?.validation?.QuoteState?.Quote?.Options[0]?.CoverPercentage || 0}
        getQuote={getQuote}
        item={props.item}
        includeServiceModel={false}
        currentSelection={item.Extras}
        onUpdate={(q, o) => {
          const _extras = item.Extras.filter((x) => !ProtectionExtraIds.includes(x.Id));
          o?.Extras.forEach((e) => {
            if (!_extras.find((x) => x.Id === e.Id)) {
              _extras.push(e);
            }
          });
          onExtrasSave(_extras);
        }}
      />
      <P2GButton onClick={onSave} colour="primary">
        {t('SAVE_BUTTON', { defaultValue: 'Save' })}
      </P2GButton>
    </>
  );
}
